// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2eFBW","item":"PaymentsMobile_item__2-KcL","label":"PaymentsMobile_label__29Okw","amount":"PaymentsMobile_amount__23uQC"};